import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "form-label",
  templateUrl: "form-label.component.html",
  styleUrls: ["form-label.component.less"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf],
  host: {
    class: "form-item-label-section",
    "[class.label-gap-sm]": `formLabelGap === 'small'`,
    "[class.label-gap-lg]": `formLabelGap === 'large'`,
    "[class.label-gap-default]": "formLabelGap === 'default'",
  },
})
export class FormLabelComponent {
  @Input() public controlId: string;
  @Input() public id: string;
  @Input() public labelText: string;
  @Input() public required: boolean;
  @Input() public formLabelGap: "small" | "default" | "large" = "default";
}
